<template>
	<div>
		<header class="main-header">
		    <nav class="navbar navbar-static-top">
		        <div class="logo" data-toggle="push-menu">
		            <b>科创网校管理平台</b>
		        </div>
		        <div class="navbar-custom-menu">
		            <ul class="nav navbar-nav">
		                <li class="dropdown user-menu mr5">
		                    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown" style="line-height: 40px;">
		                        <img src="../assets/plugins/images/user1.jpg" class="user-image">
		                        <span class="hidden-xs">{{userName}}</span>
		                    </a>
		                    <ul class="dropdown-menu">
		                        <li class="mt5">
		                            <a href="javascript:void(0)" @click="goCenter()" class="menu_node">
		                                <i class="fa fa-user"></i> &nbsp;个人中心</a>
		                        </li>
		                        <li>
		                            <a @click="goChangePwd()"
		                               class="menu_node">
		                                <i class="fa fa-key"></i> 修改密码</a>
		                        </li>
		                        <li class="divider"></li>
		                        <li>
		                            <a href="javascript:" @click="logout">
		                                <i class="fa fa-sign-ou3t"></i> 退出登录</a>
		                        </li>
		                        <li class="mt10"></li>
		                        <li class="mt10"></li>
		                    </ul>
		                </li>
		            </ul>
		        </div>
		        <!-- 功能模块导航菜单 -->
		        <div class="navbar-custom-menu pull-left" style="font-size:18px">
		            <ul class="nav navbar-nav">
		                <li class="dropdown treeview" @click="setActiveModule('home_page')" :class="{'active':activeModule=='home_page'}">
		                    <a href="javascript:" @click="goHome" class="dropdown-toggle" data-toggle="dropdown" style="padding-top:10px;padding-bottom: 8px;"
		                       data-hover="dropdown" title="首页">
		                        <div style="text-align: center;font-size: 30px;"><i class="fa fa-fw icon-home"></i></div>
								<div style="font-size: 14px;padding-left: 10px;padding-right: 10px;padding-top: 2px;padding-bottom: 0px;"><span>系统首页 </span></div>
		                    </a>
		                </li>
		                <template v-for="module in modules">
		                    <li class="dropdown treeview" v-if="module.type=='module'" :key="module.code" :class="{'active':activeModule==module.code}" @click="setActiveModule(module.code)">
		                        <a href="javascript:" @click="open('module',module.code,module.children)" style="padding-top:10px;padding-bottom: 8px;"
		                           class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown"
		                           :title="module.name">
										<div style="text-align: center;font-size: 30px;"><i class="fa fa-fw " :class="module.icon || 'icon-grid'"></i></div>
									    <div style="font-size: 14px;padding-left: 10px;padding-right: 10px;padding-top: 2px;padding-bottom: 0px;"><span>{{module.name}}</span></div>
		                        </a>
		                        <ul class="dropdown-menu" style="left: 0;right:auto"
		                            v-if="module.children.length>0 && module.children.filter(item=>item.type =='nav').length>0">
		                            <template v-for="child in module.children">
		                                <li @click="open('nav',child.code,child.children)" class="mt5"
		                                    v-if="child.type=='nav'" :key="child.code">
		                                    <a href="javascript:" class="menu_node">
		                                        <i class="fa " :class="child.icon || 'fa-external-link'"></i>{{child.name}}</a>
		                                </li>
		                            </template>
		                            <li class="mt10"></li>
		                        </ul>
		                    </li>
		                </template>
		            </ul>
		        </div>
		    </nav>
		</header>
		<ChangePwd ref="ChangePwd"></ChangePwd>
	</div>
</template>

<script>
    // import $ from 'jquery';
    import ChangePwd from '../modules/person/ChangePwd.vue';

    export default {
        name: 'Header',
        components: {ChangePwd},
        data: function () {
            return {
				showLeftSide:true
			}
        },
        computed: {
            userName: function () {
                return this.$store.state.user.zsxm || "";
            },
            modules: function () {
                return this.$store.state.privileges || [];
            },
			activeModule:function(){
				return this.$store.state.activeModule || '';
			}
        },
		created:function(){
			this.showLeftSide = this.$store.state.showLeftSide;
		},
        mounted: function () {

        },
        methods: {
			setActiveModule:function(activeModuleCode){
				this.$store.commit('setActiveModule', activeModuleCode);
				if('home_page' == activeModuleCode){
					this.$store.commit('setCurrentMenus', []);
				}
			},
            open: function (type, code, children) {
                if (type == 'nav') {
                    let currentMenus = children || [];
                    this.$store.commit('setCurrentMenus', currentMenus);
                }
                if (type == 'module') {
                    let a = children.filter(item => item.type == 'nav');
                    if (a && a.length > 0) {
                        return;
                    }
                    else {
                        let currentMenus = children || [];
                        this.$store.commit('setCurrentMenus', currentMenus);
                    }
                }
                console.log('----curr menus:', this.$store.state.currentMenus);
            },
            goHome: function () {
                this.$router.push({name: 'Home'});
            },
            goHelp: function () {
                this.$router.push({name: 'Help'});
            },
            //个人中心
            goCenter: function () {
                this.$router.push({name: 'PersonCenter'});
            },
            //修改密码
            goChangePwd: function () {
				this.$refs.ChangePwd.open();
            },
            logout: function () {
                this.$http.post("/htgl/logout").then(() => {
					this.$cookies.remove("_xunw_admin_logined");
                    this.$store.commit("initStore");
                    localStorage.removeItem("jxjy_store_user");
                    localStorage.removeItem("jxjy_store_privileges");
                    sessionStorage.removeItem("jxjy_store_breadcrumbs");
                    sessionStorage.removeItem("jxjy_store_currentMenus");
                    sessionStorage.removeItem("jxjy_store_activeMenu");
                    sessionStorage.removeItem("jxjy_store_activeModule");
                    this.$router.push({name: 'Login'});
					console.log('------reset store:',this.$store.state);
                })
            }
        }
    }
</script>

<style scoped>
    .dropdown:hover .dropdown-menu {
        display:block;
    }
</style>